import React from 'react';
import {
  Card,
  Typography,
  Avatar,
  CardHeader,
  CardBody,
  CardFooter,
  Button
} from "@material-tailwind/react";
import promotionImage from "../assets/promotion_image.png";
import { formatedDate } from '../utils';
import { FaCalendarAlt } from 'react-icons/fa';
import { useNavigate } from "react-router-dom";

const CardMyRaffle = (props) => {

  const navigate = useNavigate();

  const handleRaffleClick = (raffleId) => {
    navigate(`/raffles/${raffleId}`);
};
  
  return (
    <section >
       <Card className="mt- w-full">
     
      <CardBody>
        <div className='flex justify-between'>
          <div>
          <Avatar
            src={props.imageUrl ? props.imageUrl : promotionImage}
            size="lg"
            color="lightBlue"
            className='mb-4'
          />
          </div>
<div>
<Button onClick={()=>handleRaffleClick(props.id)}>Ver</Button>
</div>

        </div>
        <Typography variant="h5" color="blue-gray" className="mb-2">
          {props.title}
        </Typography>

        <Typography className='flex gap-2 ml-2' style={{alignItems: 'center'}}>
        <FaCalendarAlt />
        {props.drawDate ? formatedDate(props.drawDate) : ""}
        </Typography>
      </CardBody>
     
    </Card>
    </section>
  );
}

export default CardMyRaffle;
